import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import Text from '../../../Text'
import ChevronDownIcon from '../../../icons/ChevronDownIconCollapsible'
import { Collapse } from '@mui/material'
import SimpleBlockContent from '../../../SimpleBlockContent'
import { PALETTE } from '../../../../styles/constants'

function CollapsibleItem({ item, expandedInitially, textColor = PALETTE.gray80, searchTerm }) {
  const [expanded, setExpanded] = useState(expandedInitially)

  useEffect(() => {
    // at every re-render this collapsible item could be part of a new list and potentially have a different expandedInitially prop value
    setExpanded(expandedInitially)
  }, [expandedInitially])

  return (
    <div className={styles.itemWrapper} style={{ borderBottomColor: textColor }}>
      <div className={styles.itemTitle} onClick={() => setExpanded(!expanded)} style={{ color: textColor }}>
        <Text type="heading-5" highlight={searchTerm}>{item.title}</Text>
        <span className={styles.expandIcon} style={{ transform: `rotate(${expanded ? 180 : 0}deg)` }}>
          <ChevronDownIcon color={textColor}/>
        </span>
      </div>
      <Collapse
        in={expanded}
        timeout={{ enter: 500, exit: 250 }}
      >
        <div className={styles.itemText} style={{ color: textColor, '--item-link-color': textColor }}>
          <SimpleBlockContent blocks={item.text} highlight={searchTerm} />
        </div>
      </Collapse>
    </div>
  )
}

export default CollapsibleItem
